import { render, staticRenderFns } from "./TablePaginationPropsMini.vue?vue&type=template&id=235dbe30&scoped=true"
import script from "./TablePaginationPropsMini.vue?vue&type=script&lang=js"
export * from "./TablePaginationPropsMini.vue?vue&type=script&lang=js"
import style0 from "./TablePaginationPropsMini.vue?vue&type=style&index=0&id=235dbe30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235dbe30",
  null
  
)

export default component.exports